/**
 * One persistence contract for first-run education.
 *
 * V2 originally wrote a new key while the root navigator kept reading the
 * legacy key. The current session advanced, but a reload made the same person
 * look new again. Keep both names here so old completions migrate cleanly.
 */
export const ONBOARDING_STORAGE_KEY = "@fahali_onboarding_complete_v2";
export const LEGACY_ONBOARDING_STORAGE_KEY = "@fahali_onboarding_complete";

export function hasCompletedOnboarding(
  currentValue: string | null,
  legacyValue: string | null,
): boolean {
  return currentValue === "true" || legacyValue === "true";
}

/** A carried watch request is already an explicit job, so serve it first. */
export function shouldShowOnboarding(
  hasOnboarded: boolean,
  hasPendingWatch: boolean,
): boolean {
  return !hasOnboarded && !hasPendingWatch;
}
